import { useContext } from 'react';
import { type QuickView, QuickViewContext } from '.';

const useQuickView = (): QuickView => {
    const context = useContext(QuickViewContext);
    return context || {};
};

export default useQuickView;
